import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldType, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import {
	MatStepper,
	MatStep,
	MatStepLabel,
	MatStepperPrevious,
	MatStepperNext,
} from '@angular/material/stepper';
import { NgFor, NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';

/**
 * Custom Formly field type for Material Stepper
 * Wraps mat-horizontal-stepper and renders each step as a nested formly-field
 */
@Component({
	selector: 'formly-field-stepper',
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<mat-stepper [linear]="props.linear" #stepper>
			<mat-step
				*ngFor="let step of visibleSteps; let index = index; let last = last"
			>
				<ng-template matStepLabel>{{ step.props?.label }}</ng-template>
				<div class="mt-3">
					<formly-field [field]="step"></formly-field>
				</div>

				<div class="d-flex justify-content-between mt-4">
					<button
						mat-raised-button
						matStepperPrevious
						*ngIf="index !== 0"
						type="button"
					>
						Back
					</button>
					<button
						mat-raised-button
						color="primary"
						matStepperNext
						*ngIf="!last && !shouldHideNext(step)"
						type="button"
						[disabled]="!isValid(step)"
					>
						Next
					</button>
					<button
						mat-raised-button
						color="accent"
						*ngIf="(last || shouldHideNext(step)) && !shouldHideSubmit(step)"
						type="button"
						(click)="props.submit?.()"
						[disabled]="!isValid(step)"
					>
						Submit
					</button>
				</div>
			</mat-step>
		</mat-stepper>
	`,
	imports: [
		MatStepper,
		NgFor,
		MatStep,
		MatStepLabel,
		FormlyModule,
		NgIf,
		MatButton,
		MatStepperPrevious,
		MatStepperNext,
	],
})
export class FormlyFieldStepper extends FieldType {
	/**
	 * Get visible steps (filter out hidden steps)
	 */
	get visibleSteps(): FormlyFieldConfig[] {
		return this.field.fieldGroup?.filter((step) => !step.hide) ?? [];
	}

	isValid(field: FormlyFieldConfig): boolean {
		if (field.key) {
			return field.formControl?.valid || false;
		}

		return field.fieldGroup
			? field.fieldGroup.every((f) => this.isValid(f))
			: true;
	}

	shouldHideNext(step: FormlyFieldConfig): boolean {
		return step.props?.hideNextWhen?.(this.model) ?? false;
	}

	shouldHideSubmit(step: FormlyFieldConfig): boolean {
		return step.props?.hideSubmitWhen?.(this.model) ?? false;
	}
}
